import { CreditsFallback } from '@/routes/billing/credits/fallback'
import { ManageBillingFallback } from '@/routes/billing/manage-billing/fallback'

export const BillingFallback = () => {
  return (
    <div className="flex flex-col gap-4 pb-25">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <ManageBillingFallback />
        <CreditsFallback />
      </div>
    </div>
  )
}
